import React from 'react';

import { Grid } from '@mui/material';
import CustomHeader from 'components/Common/CustomHeader';
import SupplierQuestionnaireBlur from 'components/Automation/UIStepper/SupplierQuestionnaireBlur';

const SubmitQuestionnaire: React.FC = () => {
  return (
    <>
      <CustomHeader />
      <section className='home-content-body Home-HeaderDown' style={{ minHeight: 0 }} >
        <Grid container>
          <Grid item xs={12}>
            <SupplierQuestionnaireBlur/>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default SubmitQuestionnaire;
